// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"3e905d67","821":"e714c24c","977":"1ae40861"}[chunkId] + ".chunk.js";
};